import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../axiosInstance";
import { useTranslation } from "react-i18next";
import { Carousel } from "bootstrap";

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const carouselRef = useRef(null);

  const [newSpeakers, setNewSpeakers] = useState([]);
  const [mostViewedSpeakers, setMostViewedSpeakers] = useState([]);
  const isArabic = i18n.language === "ar";

  const fetchNewSpeakers = async () => {
    try {
      const response = await axiosInstance.get(
        "/api/v1/users/speakers/home?type=1"
      );
      setNewSpeakers(response.data?.items?.slice(0, 5) || []);
    } catch (error) {
      console.error("Error fetching new speakers:", error);
    }
  };

  const fetchMostViewedSpeakers = async () => {
    try {
      const response = await axiosInstance.get(
        "/api/v1/users/speakers/home?type=2"
      );
      setMostViewedSpeakers(response.data?.items?.slice(0, 4) || []);
    } catch (error) {
      console.error("Error fetching most viewed speakers:", error);
    }
  };

  useEffect(() => {
    fetchNewSpeakers();
    fetchMostViewedSpeakers();
  }, []);

  useEffect(() => {
    if (mostViewedSpeakers.length > 0 && carouselRef.current) {
      const carouselInstance = new Carousel(carouselRef.current, {
        interval: 5000,
        ride: "carousel",
      });
      carouselInstance.cycle();
    }
  }, [mostViewedSpeakers]);

  return (
    <section className="hero-light py-5">
      <div className="hero-pattern"></div>
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-lg-7 mb-5 mb-lg-0">
            <h1 className="display-4 fw-bold mb-3 text-primary-custom hero-title">
              {t("hero.title")}
            </h1>
            <p className="lead mb-5 text-dark hero-subtitle">
              {t("hero.subtitle")}
            </p>

            <div className="recently-joined-section">
              <div className="mb-3 d-inline-block">
                <span className="badge bg-primary-custom py-2 px-3 rounded-pill fs-6">
                  {t("hero.recentlyJoined")}
                </span>
              </div>
              <div className="speaker-avatars d-flex flex-wrap justify-content-center justify-content-lg-start">
                {newSpeakers.map((speaker, index) => (
                  <div
                    key={speaker.id}
                    className="speaker-avatar-wrapper"
                    style={{
                      marginRight: index !== 0 ? "-15px" : "0",
                      zIndex: 5 - index,
                    }}
                  >
                    <a href={`/speaker-detail/${speaker.id}`}>
                      <img
                        src={speaker.profileImage}
                        className="speaker-avatar"
                        alt={
                          i18n.language === "ar"
                            ? speaker.arabicFullName
                            : speaker.englishFullName
                        }
                      />
                      <div className="speaker-name-tooltip">
                        {i18n.language === "ar"
                          ? speaker.arabicFullName
                          : speaker.englishFullName}
                      </div>
                    </a>
                  </div>
                ))}

                <div
                  className="speaker-avatar-wrapper more-speakers"
                  style={{ marginRight: "-15px", zIndex: 0 }}
                >
                  <a href="/speakers">
                    <div className="speaker-avatar more-circle d-flex align-items-center justify-content-center">
                      <span>+</span>
                    </div>
                    <div className="speaker-name-tooltip">
                      {t("hero.moreSpeakers")}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5 text-center">
            <div className="featured-speaker-slider">
              <div className="last-joined-heading mb-4">
                <span className="badge bg-primary-custom py-2 px-3 rounded-pill fs-6">
                  {t("hero.featuredSpeakers")}
                </span>
              </div>
              <div
                id="featuredSpeakerCarousel"
                className="carousel slide"
                ref={carouselRef}
              >
                <div className="carousel-inner">
                  {mostViewedSpeakers.map((speaker, index) => (
                    <div
                      key={speaker.id}
                      className={`carousel-item ${index === 0 ? "active" : ""}`}
                    >
                      <a
                        href={`/speaker-detail/${speaker.id}`}
                        className="text-decoration-none"
                      >
                        <div className="featured-speaker-minimal">
                          <div className="featured-speaker-portrait">
                            <img
                              src={
                                speaker.profileImage
                              }
                              alt={
                                i18n.language === "ar"
                                  ? speaker.arabicFullName
                                  : speaker.englishFullName
                              }
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                              }}
                            />

                            <div className="featured-speaker-name">
                              <h4>
                                {i18n.language === "ar"
                                  ? speaker.arabicFullName
                                  : speaker.englishFullName}
                              </h4>
                              {/* <div > */}
                                {speaker.speakerSpecialies?.map(
                                  (speciality, index) => (
                                    <p >
                                      {isArabic
                                        ? speciality.speciality.arabicName
                                        : speciality.speciality.englishName}
                                    </p>
                                  )
                                )}
                              {/* </div> */}
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>

                <button
                  className="carousel-control-prev featured-speaker-control"
                  type="button"
                  data-bs-target="#featuredSpeakerCarousel"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">{t("carousel.prev")}</span>
                </button>
                <button
                  className="carousel-control-next featured-speaker-control"
                  type="button"
                  data-bs-target="#featuredSpeakerCarousel"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">{t("carousel.next")}</span>
                </button>

                <div className="carousel-indicators featured-speaker-indicators">
                  {mostViewedSpeakers.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      data-bs-target="#featuredSpeakerCarousel"
                      data-bs-slide-to={index}
                      className={index === 0 ? "active" : ""}
                      aria-current={index === 0}
                      aria-label={`Slide ${index + 1}`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
